(() => {
    "use strict";

    var form, submitBtn, validator;

    var KTSigninGeneral = {
        init: function () {
            form = document.querySelector("#kt_sign_in_form");
            submitBtn = document.querySelector("#kt_sign_in_submit");

            validator = FormValidation.formValidation(form, {
                fields: {
                    email: {
                        validators: {
                            notEmpty: {
                                message: "Email address is required"
                            },
                            emailAddress: {
                                message: "The value is not a valid email address"
                            }
                        }
                    },
                    password: {
                        validators: {
                            notEmpty: {
                                message: "The password is required"
                            }
                        }
                    }
                },
                plugins: {
                    trigger: new FormValidation.plugins.Trigger(),
                    bootstrap: new FormValidation.plugins.Bootstrap5({
                        rowSelector: ".fv-row",
                        eleInvalidClass: "",
                        eleValidClass: ""
                    })
                }
            });

            submitBtn.addEventListener("click", function (event) {
                event.preventDefault();

                validator.validate().then(function (status) {
                    if (status === "Valid") {
                        submitBtn.setAttribute("data-kt-indicator", "on");
                        submitBtn.disabled = true;

                        axios.post(
                            submitBtn.closest("form").getAttribute("action"),
                            new FormData(form)
                        )
                        .then(function (response) {
                            window.location.reload();
                        })
                        .catch(function (error) {
                            var data = (error.response && error.response.data) || {};
                            var messages = [];

                            for (var key in data.errors) {
                                if (data.errors.hasOwnProperty(key)) {
                                    messages = messages.concat(data.errors[key]);
                                }
                            }

                            if (!messages.length) {
                                messages.push(data.message || "Sorry, we could not sign you in. Please try again.");
                            }

                            Swal.fire({
                                text: messages.join("\n"),
                                icon: "error",
                                buttonsStyling: false,
                                confirmButtonText: "Ok, got it!",
                                customClass: {
                                    confirmButton: "btn btn-primary"
                                }
                            });
                        })
                        .then(function () {
                            submitBtn.removeAttribute("data-kt-indicator");
                            submitBtn.disabled = false;
                        });

                    } else {
                        Swal.fire({
                            text: "Sorry, looks like there are some errors detected, please try again.",
                            icon: "error",
                            buttonsStyling: false,
                            confirmButtonText: "Ok, got it!",
                            customClass: {
                                confirmButton: "btn btn-primary"
                            }
                        });
                    }
                });
            });
        }
    };

    KTUtil.onDOMContentLoaded(function () {
        KTSigninGeneral.init();
    });

})();